<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import { iconMap } from "#lib/iconMap.js";
	import type { SVGAttributes } from "svelte/elements";

	type Props = Omit<SVGAttributes<SVGSVGElement>, "name" | "width" | "height" | "class"> & {
		name?: string;
		iconSet?: string;
		height?: string | number;
		width?: string | number;
		class?: string;
		tabIndex?: number;
	};

	const { name, iconSet = "heroicons", height = 24, width = 24, ...props }: Props = $props();
	const key = $derived(name ? `${iconSet}/${name}` : "");
	const IconComponent = $derived(key ? iconMap[key] : undefined);
</script>

{#if IconComponent}
	<IconComponent {height} {width} {...props} class={twMerge("block *:stroke-[1.5]", props.class)} />
{/if}
